import { render, staticRenderFns } from "./OrderViewModal.vue?vue&type=template&id=4e9a4790&scoped=true"
import script from "./OrderViewModal.vue?vue&type=script&lang=js"
export * from "./OrderViewModal.vue?vue&type=script&lang=js"
import style0 from "./OrderViewModal.vue?vue&type=style&index=0&id=4e9a4790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9a4790",
  null
  
)

export default component.exports